<script>
export default {
  props: {
    maxTabsToShow: Number,
    selectedTab: Number,
    tabs: Array,
    type: {
      type: String,
      default: 'default'
    }
  },
  data () {
    return {
      overflowOpen: false,
      tabsWithError: []
    }
  },
  methods: {
    changeOverflowTab (tab) {
      this.$emit('changeOverflowTab', { tab })
      this.overflowOpen = false
    },
    clearTabErrors () {
      this.tabsWithError = []
    },
    setError (tab, isError) {
      if (isError) {
        if (!this.tabsWithError.includes(tab)) {
          this.tabsWithError.push(tab)
        }
      } else if (this.tabsWithError.includes(tab)) {
        this.tabsWithError.splice(this.tabsWithError.indexOf(tab), 1)
      }
    },
    setActiveTab (index) {
      this.$emit('changeTab', { tab: this.tabs[index].id })
    }
  },
  computed: {
    aClass () {
      if (this.type === 'vertical') {
        return 'slds-vertical-tabs__link'
      } else if (this.type === 'default') {
        return 'slds-tabs_default__link'
      } else {
        return ''
      }
    },
    liClass () {
      if (this.type === 'vertical') {
        return 'slds-vertical-tabs__nav-item'
      } else if (this.type === 'default') {
        return 'slds-tabs_default__item'
      } else {
        return ''
      }
    },
    ulClass () {
      if (this.type === 'vertical') {
        return 'slds-vertical-tabs__nav'
      } else if (this.type === 'default') {
        return 'slds-tabs_default__nav'
      } else {
        return ''
      }
    }
  }
}
</script>
<template>
  <ul :class="ulClass" role="tablist" :aria-orientation="type">
    <li
      role="presentation"
      v-for="(tab, index) in tabs.slice(0, maxTabsToShow)"
      @click="$emit('changeTab', { tab: tab.id })"
      :key="tab.id"
      :class="{ [liClass]: true, 'slds-is-active': tab.id === selectedTab}"
      :title="tab.label">
      <a
        href="javascript:void(0);"
        role="tab"
        :aria-selected="tab.id === selectedTab"
        :aria-controls="`tab-${index}`"
        :class="{ [aClass] : true, 'error': tabsWithError.includes(tab.id)}"
        :id="`tab-1__${index}`"
        :tabindex="index">

        <span class="slds-truncate" title="Tab 1">
          {{tab.label}}
        </span>

        <transition name="fade">
          <span class="slds-tabs__right-icon" v-if="tabsWithError.includes(tab.id)">
            <span class="slds-icon_container slds-icon-utility-error">
              <svg class="slds-icon slds-icon_x-small slds-icon-text-error" aria-hidden="true">
                <use xlink:href="../../../assets/symbols.svg#error"></use>
              </svg>
            </span>
          </span>
        </transition>
      </a>
    </li>
    <li v-if="tabs.length > maxTabsToShow" class="more-button">
      <div class="slds-dropdown-trigger" :class="overflowOpen ? 'slds-dropdown-trigger_click slds-is-open' : ''" v-click-outside="{callback: () => {overflowOpen = false}, enable: true}">
        <button class="slds-button" aria-haspopup="true" :title="$t('general.more')" @click="overflowOpen = !overflowOpen">
          <span class="slds-indicator-container"></span>
          <span class="slds-truncate" :title="$t('general.more')">
            {{$t('general.more')}}
          </span>
          <svg class="slds-button__icon slds-button__icon_small slds-button__icon_right" aria-hidden="true">
            <use xlink:href="../../../assets/symbols.svg#chevrondown"></use>
          </svg>
        </button>
        <div class="slds-dropdown slds-dropdown_right" v-if="overflowOpen">
          <ul class="slds-dropdown__list" role="menu">
            <li
              class="slds-dropdown__item slds-has-notification"
              role="presentation"
              v-for="(tab, index) in tabs.slice(maxTabsToShow, tabs.length)"
              :key="index"
              @click="changeOverflowTab(tab.id)">
              <a href="javascript:void(0);" role="menuitem" tabindex="-1">
                <span class="slds-truncate" :title="tab.label">
                  <span>{{tab.label}}</span>
                </span>
              </a>
            </li>
          </ul>
        </div>
      </div>
    </li>
  </ul>
</template>

<style scoped>
  .error {
    color: #C23933;
  }
  .more-button {
    display: flex;
    flex-direction: row;
    align-items: center;
    color: #3e3e3c;
    position: relative;
    padding: 0 0.75rem;
    margin-bottom: -1px;
  }
</style>
